import { API } from "aws-amplify";
import {
  resolveCorporateFacilityIdForRequest,
  queryWithSelectedCorporateFacId,
} from "./facilityLambdaHelpers";

const getCalendarTypes=async(throwOnError=false)=>{

    try {
      // Fixed: was resolveLambdaFacilityId() — see docs/signage/corporate-facility-id-fix.md.
      const corporateFacilityId = await resolveCorporateFacilityIdForRequest();
      const response = await API.get('lambda', '/room-types/list', {
        queryStringParameters: queryWithSelectedCorporateFacId({}, corporateFacilityId),
      });
    //  console.log("operation Successfull for Calendar Types list"+JSON.stringify(response));
     if(response.Success===true)
     {
        return response.Content.Result;
     }
    return []
    } catch (error) {
      console.log("Something went wrong while Fetching Calendar TypesList"+error.message);
      if(throwOnError) throw error;
      return [];
  }
  };

export default getCalendarTypes;

